// extracted by mini-css-extract-plugin
export var editButton = "_ir-0";